import { toast } from 'react-toastify';

// Standard toast configuration
const defaultToastConfig = {
    position: "top-center" as const,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true
};

// Success toast with shorter duration
export const showSuccessToast = (message: string) => {
    toast.success(message, {
        ...defaultToastConfig,
        autoClose: 3000
    });
};

// Error toast with longer duration
export const showErrorToast = (message: string) => {
    toast.error(message, {
        ...defaultToastConfig,
        autoClose: 5000
    });
};

// Warning toast
export const showWarningToast = (message: string) => {
    toast.warning(message, {
        ...defaultToastConfig,
        autoClose: 4000
    });
};